import { createSelector } from 'reselect'

const getBackgroundCanvas = state => state.backgroundCanvas

export const getCurrentRowIndex = createSelector(
  [getBackgroundCanvas],
  bg => bg.get('rowIndex')
)

export const getNearestRowIndex = createSelector(
  [getBackgroundCanvas],
  bg => {
    const deltas = bg.get('rowDeltas')
    const st = bg.get('rowSt')
    
    // walk through the slides from the top while keeping in mind 
    // the last one yet inside the viewport
    return deltas.reduce((currentIndex, dy, index) => (
      (st > dy) ? index + 1 : currentIndex
    ), 0)
  }
)
 


// WEBPACK FOOTER //
// ./src/components/background-canvas/selectors.js